import { IBankCategoryMapping } from '@/services/banking/BankCategoryService';

export const isFetching = (state: any, isFetching: boolean) => {
    state.isFetching = isFetching;
}

export const allMappings = (state: any, mappings: IBankCategoryMapping[]) => {
    state.allMappings = mappings;
}

export const allCategories = (state: any, categories: string[]) => {
    state.allCategories = categories;
}
